import React from 'react';
import { PRIORITY_META, priority_of } from './priority';
import type { PriorityItem } from './priority';

export function PriorityBadge({ item }: { item: PriorityItem }) {
  const meta = PRIORITY_META[priority_of(item)];
  return (
    <span
      className="inline-block px-2 py-0.5 rounded-full text-xs font-bold whitespace-nowrap"
      style={{ background: meta.bg, color: meta.fg }}
      title={meta.title}
    >
      {meta.label}
    </span>
  );
}

export function OnLeaveBadge() {
  return (
    <span className="inline-block px-1.5 py-0.5 rounded-full text-xs leading-none font-medium bg-state-warning-bg text-state-warning-text whitespace-nowrap">
      On leave
    </span>
  );
}

export function Muted({ children }: { children: React.ReactNode }) {
  return <span className="text-content-muted">{children}</span>;
}

export interface OwnerItem {
  owner_ops_uuid?: string | null;
  owner_name?: string | null;
  owner_on_leave?: boolean;
}

export function OwnerCell({ item }: { item: OwnerItem }) {
  let name: React.ReactNode = item.owner_name;
  if (!name) name = item.owner_ops_uuid ? 'Owner' : <Muted>No owner</Muted>;
  return (
    <span className="inline-flex items-center gap-1.5 flex-wrap">
      {name}
      {item.owner_on_leave ? <OnLeaveBadge /> : null}
    </span>
  );
}
